import { api } from "./client";

export interface PaycomPreviewEmployee {
  employeeId: string;
  email: string | null;
  displayName: string;
  jobTitle: string | null;
  department: string | null;
  hasMobile: boolean;
  action: "create" | "update" | "skip";
  skipReason?: string;
}

export interface PaycomSyncResult {
  created: number;
  updated: number;
  skipped: number;
  errors: { employeeId: string; email: string | null; reason: string }[];
}

export const paycomApi = {
  status: () =>
    api.get<{ configured: boolean }>("/paycom/status").then((r) => r.data),

  preview: () =>
    api.get<PaycomPreviewEmployee[]>("/paycom/preview").then((r) => r.data),

  sync: () =>
    api.post<PaycomSyncResult>("/paycom/sync").then((r) => r.data),
};
